import { takeEvery } from 'redux-saga/effects';
import listener from '../goldenLayoutListener';
import actions from '../constants';

export default function* layoutManagerSaga() {
  yield takeEvery(actions.UPDATE_SHOW_LABELS, listener.onToggleLabels);
  yield takeEvery(actions.UPDATE_LAYOUT, listener.onChangeLayout);
  yield takeEvery(actions.TOGGLE_RIBBON, listener.onToggleRibbon);
}
